export const LOGO_url = '/assets/images/logo.png';
